import React from "react";
import { Stack } from "@mui/material";

const Loader = () => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      width="100%"
    ></Stack>
  );
};

export default Loader;
